module.exports = __webpack_public_path__ + "static/media/love.816f4c27.svg";